<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
.inputStyle{
    background-color: #ffffff;
    border: 1px solid #E4E6EF;
    height: 40px;
    border-radius: 5px;
}
</style>

<template>
    <div class="card">
        <div class="card-header">
            <div class="card-title">                   
                <span class="card-label fw-bolder fs-3 mb-1 titleStyle" style="line-height: 30px; vertical-align: middle;"> <i class="fa fa-angle-double-left mr-2" style=" cursor: pointer; font-size: 30px;color: #1e5c9e; vertical-align: middle;" @click="callStock"></i> รายการสินค้า</span>
            </div>
            <div class="card-toolbar">
                <div>
                <span style="font-weight: bold;">วันที่:</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-date-picker
                        v-model="createDate"
                        type="date"
                        placeholder="Pick a day"
                        :size="size"
                        style="max-width: 150px"  
                        format="DD/MM/YYYY"
                        value-format="YYYY-MM-DD"
                        @change="changeDate"
                    />
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;  
                <div>
                <span style="font-weight: bold;">ปลายทาง:</span>&nbsp;&nbsp;&nbsp;&nbsp;  
                    <el-select
                        v-model="selectedWarehouseID"
                        collapse-tags
                        style="text-align: left; max-width: 170px"
                        id="textLeft"
                        placeholder="เลือกคลังปลายทาง"
                        @change="changeWarehouse"
                    >
                        <el-option
                            v-for="item in warehouseOption"
                            :key="item.warehouseID"
                            :label="item.warehouseName"
                            :value="item.warehouseID" 
                        >
                        </el-option>            
                    </el-select> 
                </div>
                <div>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <span style="font-weight: bold;">พาร์ทเนอร์:</span>&nbsp;&nbsp;&nbsp;&nbsp;  
                    <el-select
                        v-model="selectedPartnerCode"
                        collapse-tags
                        style="text-align: left; max-width: 170px"
                        id="textLeft"
                        placeholder="เลือกพาร์ทเนอร์"
                        :disabled="selectedWarehouseID!=45"
                        filterable
                        @change="changeToPartner"
                    >
                        <el-option
                            v-for="partnerOption in arrPartnerOption"
                            :key="partnerOption.partnerCode"
                            :label="partnerOption.partnerName"
                            :value="partnerOption.partnerCode"
                        >
                        </el-option>            
                    </el-select>                    
                </div>
               
            </div>           
        </div>
        <div class="card-toolbar">

        </div>
        <div class="card-body" style="padding: 0rem 5rem; margin-bottom: 20px;">
            <div class="py-1">
                <table class="table table-row-dashed table-row-gray-300 gy-7">
                    <thead>
                    <tr border-bottom
                    fs-7
                    fw-bolder
                    text-gray-700 text-uppercase>
                        <th class="min-w-40px w-40px">#</th>
                        <th class="min-w-150px w-150px">ชื่อสินค้า</th>
                        <th class="pt-8 pe-7 min-w-100px w-100px text-end">คงเหลือ(เส้น)</th>
                        <th class="pt-8 pe-7 min-w-100px w-100px text-end">จำนวนคืน(เส้น)</th>
                        <th class="pt-8 pe-7 min-w-100px w-100px text-end">น้ำหนักคืน(กก.)</th>
                        <th class="pt-8 pe-7 min-w-50px w-50px text-end"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(product, index) in products"
                        :key="index"                
                    >
                        <td class="pt-8 pe-7">{{ index + 1 }}</td>
                        <td class="pt-8 pe-7">{{ product.productName }}</td>
                        <td class="pt-8 pe-7 text-end">{{ numberWithCommas(product.stockQuantity, 0) }}</td>
                        <td class="ps-0 text-end">                           

                            <input
                            class="inputStyle text-end"
                            type="number"
                            min="1"
                            step="any"
                            v-model="product.returnQuan"
                            data-kt-element="returnQuan"
                            style="width: 70px;"  
                            @input="change($event, product)"
                            @change="change($event, product)"        
                            /> 
                            <div style="color: red;" v-if="product.isValid">จำนวนที่ระบุเกินจากจำนวนคงเหลือ</div>
                        </td>
                        <td class="pt-8 pe-7 text-end">{{ numberWithCommas(sumWeight(product)) }}</td>
                        <td class="pt-8 pe-7 text-end">
                            <span style="cursor: pointer" @click="deleteItem(index)"><i class="fa fa-trash"></i></span>
                        </td>
                    </tr>
                    </tbody>
                </table> 
                <div class="text-center p-10" v-if="products.length == 0">
                <p class="fs-4 fw-bolder text-gray-500 mb-10">
                    ไม่มีรายการสินค้า
                </p>
                <button
                    class="btn btn-text-primary"
                    type="button"
                    @click="showSearchProductModal"
                >
                    เพิ่มสินค้า
                </button>
                </div>                
            </div>  
            <div class="separator separator-dashed mb-10"></div>     
          <div class="row fw-bolder text-gray-700">
            <div class="col-md-6 mb-10">
                <div class="col-md-6">
                    <button
                        class="btn btn-light-primary"
                        type="button"
                        @click="showSearchProductModal"
                    >
                        เพิ่มสินค้า
                    </button>                    
                </div>
                <br>        
                <div class="row">
                <div class="col-md-6">
                    <label for="">ทะเบียนรถ :</label>
                    <!-- &nbsp;<label style="color: red" for="">*</label> -->
                    <el-input v-model="truckCode" width="100" clearable maxlength="10" show-word-limit />
                    <span style="color: red" v-if="!isValidTruckCode && truckCode == '' ">** กรุณาใส่ทะเบียนรถ **</span>
                </div> 
                <div class="col-md-6">
                    <div style="margin-top: 15px;">
                        <button
                        class="btn btn-primary"
                        type="button"
                        @click="showTruckModal"
                        >
                        เลือกทะเบียนรถ
                        </button>                        
                    </div>
                </div>                 
                </div>            
                <br>
                <div class="col-md-12">
                    <label for="">หมายเหตุ :</label>
                    <el-input type="textarea" v-model="remark" width="100" clearable maxlength="100" show-word-limit />
                </div>                
            </div>
            <div class="col-md-6 col-lg-5 offset-lg-1 fs-5" style="padding-top: 90px;">
              <div class="d-flex flex-row justify-content-between mb-6">
                <div>จำนวนรวม</div>
                <div>{{ numberWithCommas(quanTotal, 0) }}&nbsp;&nbsp;&nbsp;เส้น</div>
              </div>
              <div class="d-flex flex-row justify-content-between mb-6">
                <div>น้ำหนักรวม</div>
                <div>{{ numberWithCommas(weightTotal, 2) }}&nbsp;&nbsp;&nbsp;กก.</div>
              </div>              
              <!-- <div class="separator separator-dashed my-5"></div> -->
              <el-button type="primary" style="width: 100%" :loading="btnLoading" :disabled="isDisabledButtonSubmit || (this.products.length === 0)" @click="confirmReturn">บันทึก</el-button>
            </div>
          </div>            
        </div>
    <search-product-modal
      v-model="products"
      ref="searchProductModalRef"
    ></search-product-modal>     
    <search-truck-modal
      v-model="truckCode"
      ref="searchTruckModalRef"
      :toPartnerCode="selectedPartnerCode"
      @select="onSelectTruckCode"
    ></search-truck-modal>            
    </div>   
</template>

<script>

import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas } from "@/utils";
import Swal from "sweetalert2/dist/sweetalert2.js";
import SearchProductModal from "@/components/modals/search/SearchProductModal";
import SearchTruckModal from "@/components/modals/search/SearchTruckModal";
import { array } from 'yup/lib/locale';
import { forEach } from 'lodash';

export default {
    created() {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1; // Months are zero-based
        const day = currentDate.getDate();        
        this.createDate = day+'/'+month+'/'+year;
    },    
    props: {
        mode: String,
        voucherCode: String,
        voucherBranch: String,
    },    
    components: {
        SearchProductModal,
        SearchTruckModal
    },        
    mounted: function () {
        setCurrentPageBreadcrumbs("คืนสินค้า", []);
        this.getPartner("");
        this.getWarehouse();
        this.getPartnerDetail();
        if(this.mode=="M")
        {
            this.getProducts();
        }
        // console.log(this.createDate);
    },    
    data(){
        return{
            setHeight: window.innerHeight - 340,
            products: [],
            trucks: [],
            returnQuan: null,
            mynumber: "",
            isValid: true,
            isIndex: null,
            isDisabledButtonSubmit: false,
            truckCode: "",
            remark: "",
            btnLoading: false,
            isValidTruckCode: true,
            createDate: null,
            warehouseOption: null,
            selectedWarehouseID: null,
            selectedPartnerCode: null,
            TransferStoreHead: null,
            TransferStoreDetail: null,
            isLoading: false,
            productAll: [],
            toPartnerName: "",
        };
    },   
    computed:{
        quanTotal() {
            return this.products.reduce((acc, curr) => acc + this.sumQuan(curr), 0);
        }, 
        weightTotal() {
            return this.products.reduce((acc, curr) => acc + this.sumWeight(curr), 0);
        },              
    },
    watch: {
        "$route.query.prods": {
            immediate: true,
            handler: function (val) {
                if (!val) return;
                if (Array.isArray(val)) {
                this.findProducts(val);
                } else {
                this.findProducts([val]);
                }
            },
        },
    },
    methods: {
        findProducts: async function (productIds) {
            const { data } = await ApiService.query("products", {
                params: { productIds: productIds.join(), partnerCode: this.partnerCode },
            });

            this.products = data;

            for (let index = 0; index < this.products.length; index++) {
                this.products[index].isValid = false;  
            }
        },
        sumQuan(product) {
            const { returnQuan } = product;
            return (
                (isNaN(returnQuan) ? 0 : returnQuan)
            );
        },
        sumWeight(product){
            const { returnQuan, productWeight } = product;
            return (
                (isNaN(returnQuan) ? 0 : returnQuan) *
                (isNaN(productWeight) ? 0 : productWeight)
            );
        },
        confirmReturn: async function (){
            // this.isValidTruckCode = this.truckCode == "" ? false : true;      
            
            if(this.$route.params.basePartnerCode === this.selectedPartnerCode)
            {
                Swal.fire({
                    html: "ไม่สามารถบันทึกได้!!!<br>เนื่องจากคลังต้นทางและคลังปลายทางเป็นคลังเดียวกัน",
                    icon: "warning",
                    buttonsStyling: false,
                    confirmButtonText: "ปิด",
                    allowOutsideClick: false,
                    customClass: {
                    confirmButton: "btn btn-primary",
                    },
                });                
                return;
            }            

            if(this.products.filter(value => value.returnQuan === null).length > 0)
            {
                Swal.fire({
                    html: "ไม่สามารถบันทึกได้!!!<br>เนื่องจากมีบางรายการยังไม่ได้ระบุจำนวน",
                    icon: "warning",
                    buttonsStyling: false,
                    confirmButtonText: "ปิด",
                    allowOutsideClick: false,
                    customClass: {
                    confirmButton: "btn btn-primary",
                    },
                });                
                return;
            }            

                if((this.selectedWarehouseID!=45 && this.selectedPartnerCode==null) || (this.selectedWarehouseID=45 && this.selectedPartnerCode!=null)){
                    this.btnLoading = !this.btnLoading;

                    const productKeys = this.products.map((data) => data.productID + "|" + data.productWeight + "|" + data.returnQuan).join(",");

                    this.btnLoading = !this.btnLoading;

                    try{
                        const { data } = await ApiService.post("TransferStore/ReturnProduct", {
                        Products: productKeys,
                        TruckCode: this.truckCode,
                        Remark: this.remark,
                        CreateDate: this.createDate,
                        ToPartnerCode: this.selectedPartnerCode,
                        Mode: this.mode,
                        VoucherCode: this.voucherCode,
                        });

                        if(data["success"] == 1){
                            Swal.fire({
                                text: data["error_Text"],
                                icon: "success",
                                timer:1500,
                                showCancelButton: false,
                                showConfirmButton: false,                  
                                allowOutsideClick: false,
                                didDestroy: () => {
                                    this.$router.push({ name: 'return' })
                                },
                            });
                        }else if(data["success"] == 0){
                            Swal.fire({
                                text: data["error_Text"],
                                icon: "error",
                                buttonsStyling: false,
                                confirmButtonText: "ปิด",
                                allowOutsideClick: false,
                                customClass: {
                                confirmButton: "btn btn-primary",
                                },
                            });
                        }
                    }catch (error){
                        Swal.fire({
                            text: "เกิดข้อผิดพลาด ไม่สามารถทำรายการได้!",
                            icon: "warning",
                            buttonsStyling: false,
                            confirmButtonText: "ปิด",
                            allowOutsideClick: false,
                            customClass: {
                            confirmButton: "btn btn-primary",
                            },
                        }); 
                    }  
                }
                else
                {
                        Swal.fire({
                            text: "กรุณาเลือกพาร์ทเนอร์ปลายทาง",
                            icon: "warning",
                            buttonsStyling: false,
                            confirmButtonText: "ปิด",
                            allowOutsideClick: false,
                            customClass: {
                            confirmButton: "btn btn-primary",
                            },
                        });                 
                } 
     
        },
        isNumberValid: function(inputNumber, product) {
            const stock = product.stockQuantity
            if(inputNumber>stock){
                product.isValid = true;
                this.isDisabledButtonSubmit = true;
            }else{
                product.isValid = false;
                this.isDisabledButtonSubmit = false;
            }
        },
        deleteItem(index){
            this.products.splice(index, 1);
        },
        showSearchProductModal() {
            this.$refs.searchProductModalRef.show();
        },        
        callStock(){
            this.$router.go(-1);
        },
        getWarehouse: async function (){
            const { data } = await ApiService.query("Warehouse/GetWarehouseForReturnProduct", {
                params: { PartnerCode: this.partnerCode },
            });
            
            this.warehouseOption = data;      
        },
        getPartnerDetail: async function()
        {
            const {data} = await ApiService.query("partners/me")
            this.selectedWarehouseID = data.warehouseIDRef;
        },        
        getPartner: async function(query)
        {
            const {data} = await ApiService.query("data-options/partners", {query})
            this.arrPartnerOption = data
        },        
        changeWarehouse(){
            if(this.selectedWarehouseID!=45){
                this.selectedPartnerCode=null;
                this.remark = "ย้ายสินค้าจาก: " + this.arrPartnerOption.filter((p) => p.partnerCode == this.$route.params.basePartnerCode)[0]["partnerName"] + " ไป " + this.warehouseOption.filter((p) => p.warehouseID == this.selectedWarehouseID)[0]["warehouseName"];
            }
        },
        change:function(e, product){
            const number = e.target.value
            this.isNumberValid(number,product);
        },        
        getProducts: async function () {
            try {
                const { data } = await ApiService.query("products", {params: {"markup": true}});
                this.productAll = data;
            } catch (error) {
                console.log(error);
            } finally{
                this.getTransferStoreHeadByCode();
            }
        },        
        getTransferStoreHeadByCode: async function (){
            const { data } = await ApiService.query("transferstore/GetTransferStoreHeadByCode?code=" + this.voucherCode + "&branch=" + this.voucherBranch);

            this.truckCode = data.tfTruckCode;
            this.remark = data.tfRemark;
            this.selectedWarehouseID = data.tfToWarehouseID;
            this.selectedPartnerCode = data.tfPartnerCode;
            this.createDate = data.tfDate;

            data.transferStoreD.forEach(e => {
                this.products.push({
                    productName: e.tfdProdName,
                    productID: e.tfdProdID,
                    stockQuantity: this.productAll.find(w => w.productID==e.tfdProdID).stockQuantity,
                    returnQuan: e.tfdQuantity,
                    productWeight: e.productWeight,
                    isValid: false,
                });
            });
        },  
        getTransferStoreDetailByCode: async function()
        {
            const { data } = await ApiService.query("transferstore/GetTransferStoreDetailByCode?code=" + this.voucherCode + "&branch=" + this.voucherBranch);
            this.TransferStoreDetail = data;
        },
        showTruckModal() {
            this.$refs.searchTruckModalRef.show();
        },   
        onSelectTruckCode(truckCode) {
            this.truckCode = truckCode.driverNumber;
        },           
        changeToPartner(data) {
            this.remark = "ย้ายสินค้าจาก: " + this.arrPartnerOption.filter((p) => p.partnerCode == this.$route.params.basePartnerCode)[0]["partnerName"] + " ไป " + this.arrPartnerOption.filter((p) => p.partnerCode == data)[0]["partnerName"];
        }, 
        changeDate(){
            this.remark = "ย้ายสินค้าจาก: " + this.arrPartnerOption.filter((p) => p.partnerCode == this.$route.params.basePartnerCode)[0]["partnerName"] + " ไป " + this.warehouseOption.filter((p) => p.warehouseID == this.selectedWarehouseID)[0]["warehouseName"];
        },                                        
        numberWithCommas
    }    
}
</script>